// @flow
import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Widget from 'app/components/Widget';
import BulletList from 'app/components/BulletList';
import styles from './WidgetLatestMusics.styles';
import api from 'utils/API';
  
class WidgetLatestMusics extends React.Component<Props> {
    unmounted = false;

    constructor(props) {
      super(props);

      this.state = {
        list: []
      };
    }

    componentDidMount() {
      api.post('/category/%D9%85%D9%88%D8%B3%DB%8C%D9%82%DB%8C', {
        id: 'موسیقی',
        page: 1,
        count: 5
      })
      .then(response => {
        if (this.unmounted) {
          return;
        }
        const list = response.data.list || [];
        this.setState({list});
      });
    }

    componentWillUnmount() {
      this.unmounted = true;
    }

    render() {
      // const {classes} = this.props;
      return (
        <Widget gray title='موسیقی'>
          <BulletList list={this.state.list} />
        </Widget>
      );
    }
}

const Component = withStyles(styles)(WidgetLatestMusics);
export {Component as WidgetLatestMusics}